import { Provider } from '@angular/core';
import { DashboardRepositoryPort } from '../domain/repositories/dashboard.repository.port';
import { DashboardRepository } from './repositories/dashboard.repository';

export const DASHBOARD_PROVIDERS: Provider[] = [
  {
    provide: DashboardRepositoryPort,
    useClass: DashboardRepository,
  },
];
